import axios from 'axios'
import {Message } from 'element-ui';

export default axios.create({
    baseURL: 'https://www.qizhi.com/attendance',
    timeout: 10000
})
export function addFeedBack(data) {
    // return request({
    //   url: "/feedBack/comm/add",
    //   method: "post",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   data,
    // });
    // let info = '';
    axios.post('https://www.qizhin.com/energy/feedBack/comm/add', data,{timeout: 20000})
    .then(response => {
        console.log(response)
        Message.success({
          type: 'info',
          message: response.data.msg
        });
    //   info = response.data
      Promise.resolve(response.data);
    }).catch(error => {
      console.log(error)
    //   this.errored = true
    Promise.resolve(error);
    })
  }


// WEBPACK FOOTER //
// ./src/api/index.js